import { AbstractModel, FileData, isNullOrUndefined, DateUtil } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { Amenity } from './amenity';
import { Automobile } from './automobile';
import { VehicleOwnershipType } from './vehicle-ownership-type';
import { VehicleType } from './vehicle-type';

@inheritSerialization(AbstractModel)
export class Vehicle extends AbstractModel {
  @autoserialize
  claraVehicleIdentifier: number;

  @autoserialize
  driverId: number;

  @autoserializeAs(Automobile)
  automobile: Automobile;

  @autoserialize
  licensePlate: string;

  @autoserialize
  color: string;

  @autoserialize
  active: boolean;

  @autoserialize
  suspended: boolean;

  @autoserializeAs(VehicleType)
  vehicleType: VehicleType;

  @autoserialize
  vehicleOwnershipTypeId: number;

  @autoserializeAs(Amenity)
  amenities: Array<Amenity>;

  @autoserialize
  vehicleIdentificationNumber: string;

  // Not serialized. Only used in app
  imageFile: FileData;

  /**** Serialization ****/

  static OnSerialized(instance: Vehicle, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.licensePlate)) {
      json.licensePlate = instance.licensePlate.toUpperCase();
    }
  }

  static OnDeserialized(instance: Vehicle, json: any): void {
    super.OnDeserialized(instance, json);
  }

  get displayVehicle(): string {
    return this.automobile.year + ' ' + this.automobile.automobileModel.automobileMake.name + ' ' + this.automobile.automobileModel.name;
  }
}
